export default "__VITE_ASSET__KgEbxLjE__"